var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAboutB(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M7.047 8.575 1.5 7.36 5.124 17.5l15.102-2.874.024-11.098-4.956 3.318L10.413 2.5 7.047 8.575ZM12.5 22c4.142 0 7.5-.56 7.5-1.25s-3.358-1.25-7.5-1.25c-4.142 0-7.5.56-7.5 1.25S8.358 22 12.5 22Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutB);
export default __webpack_public_path__ + "static/media/about_b.6dba475d53d8d60c86b66d8a67cd9ea5.svg";
export { ForwardRef as ReactComponent };